import { render, staticRenderFns } from "./erCalendar.vue?vue&type=template&id=37bc3fb9&"
import script from "./erCalendar.vue?vue&type=script&lang=js&"
export * from "./erCalendar.vue?vue&type=script&lang=js&"
import style0 from "./erCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports